import isElectron from 'is-electron';
import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import { OpenFeatureProvider } from '@openfeature/react-sdk';
import { ThemeProvider } from 'styled-components';
// Keep /store import higher, as many utils import it
import { store } from './store';
import { ConfirmationServiceProvider } from './utils/ConfirmationServiceContext/confirmationContext';
import * as serviceWorker from './serviceWorker';
import { faviconHandler } from './utils/faviconHandler';
import { darkTheme } from './theme/theme';
import GlobalStyle from './theme/globalStyle';
import { I18nextProvider } from 'react-i18next';
import i18n from './i18n';
import { CheckRequiredAppVersion } from './components/CheckRequiredAppVersion/CheckRequiredAppVersion';
import { RouterProvider } from 'react-router-dom';
import { router } from './routes/AllRoutes';
import { initializeAxiosInterceptor } from './apis/utils/provider';
import { FeatureFlagsSync, ensureFeatureFlagsProvider } from './featureFlags';

// Initialize axios interceptor for token refresh handling
initializeAxiosInterceptor();

// Best-effort warm-up: start binding the flag provider early. Route loaders
// await readiness before tenant resolution; this only rebinds on region change.
void ensureFeatureFlagsProvider();

if (!isElectron()) faviconHandler();

ReactDOM.render(
  <React.StrictMode>
    <Provider store={store}>
      <OpenFeatureProvider>
        <FeatureFlagsSync />
        <ConfirmationServiceProvider>
          <ThemeProvider theme={darkTheme}>
            <GlobalStyle />
            <I18nextProvider i18n={i18n}>
              <CheckRequiredAppVersion>
                <RouterProvider router={router} />
              </CheckRequiredAppVersion>
            </I18nextProvider>
          </ThemeProvider>
        </ConfirmationServiceProvider>
      </OpenFeatureProvider>
    </Provider>
  </React.StrictMode>,
  document.getElementById('root')
);

serviceWorker.unregister();
